// Accordion.js
import React from "react";

const Accordion = ({ title, children, isOpen, onClick }) => {
  return (
    <div className="border-gray-20 border-b">
      <button
        onClick={onClick}
        className="bg-gray flex w-full items-center justify-between p-4 text-left hover:bg-gray-200 focus:outline-none"
      >
        <span className="font-medium">{title}</span>
        <span>{isOpen ? "-" : "+"}</span>
      </button>
      {/* Conditional rendering for the accordion content */}
      {isOpen && <div className="bg-white p-4">{children}</div>}
    </div>
  );
};

export default Accordion;
